// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Chat container layout */
.chat-container {
  display: flex;
  flex-direction: column;
  height: 80vh; /* Full viewport height */
  max-width: 800px;
  margin: auto;
}

/* Center chat input when no messages exist */
.centered-chat {
  justify-content: center; /* Center input vertically */
}

/* Chat messages container (scrollable) */
.chat-box {
  flex-grow: 1; /* Expands when chat starts */
  overflow-y: auto;
  border-radius: 10px;
  /*border: 1px solid #ddd;*/
  display: flex;
  flex-direction: column;
}

/* Chat messages should be scrollable */
.chat-messages {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  max-height: calc(100vh - 200px); /* Prevents overflow */
}

/* Placeholder for empty chat */
.empty-chat-placeholder {
  text-align: center;
  font-size: 18px;
  color: #777;
  margin: auto;
}

/* Individual chat messages */
.chat-message {
  margin-bottom: 10px;
  padding: 8px 12px;
  border-radius: 8px;
  max-width: 75%;
}

/* User messages */
.chat-message.user {
  align-self: flex-end;
  background: #10a37f;
  color: white;
}

/* Assistant messages */
.chat-message.assistant {
  align-self: flex-start;
  background: var(--bg-color-back);
}

/* Sticky chat input */
.chat-input-container {
  display: flex;
  align-items: center;
  padding: 12px;
  position: sticky;
  margin-top: 10px;
  border: 1px solid var(--bs-border-color-translucent);
  border-radius: 8px;
  bottom: 0;
  width: 100%;
}

/* Chat input field */
.chat-input {
  flex-grow: 1;
  border: none;
  outline: none;
  font-size: 16px;
  padding: 12px 15px;
  border-radius: 8px;
}

/* Chat input focus */
.chat-input:focus {
  box-shadow: 0 0 0 .25rem rgba(255, 77, 196, 0.25);
  border: 0px solid #b3b3b3;
}

/* Send button (up arrow) */
.send-btn {
  background: #10a37f;
  color: white;
  border: none;
  padding: 10px 14px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s ease-in-out;
  margin-left: 10px;
}

.send-btn:hover {
  background: #0e8c6a;
}

/* Up arrow icon size */
.send-btn svg {
  font-size: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Chat.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY,EAAE,yBAAyB;EACvC,gBAAgB;EAChB,YAAY;AACd;;AAEA,6CAA6C;AAC7C;EACE,uBAAuB,EAAE,4BAA4B;AACvD;;AAEA,yCAAyC;AACzC;EACE,YAAY,EAAE,6BAA6B;EAC3C,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;AACxB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,+BAA+B,EAAE,sBAAsB;AACzD;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA,6BAA6B;AAC7B;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,oDAAoD;EACpD,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,iDAAiD;EACjD,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,eAAe;AACjB","sourcesContent":["/* Chat container layout */\n.chat-container {\n  display: flex;\n  flex-direction: column;\n  height: 80vh; /* Full viewport height */\n  max-width: 800px;\n  margin: auto;\n}\n\n/* Center chat input when no messages exist */\n.centered-chat {\n  justify-content: center; /* Center input vertically */\n}\n\n/* Chat messages container (scrollable) */\n.chat-box {\n  flex-grow: 1; /* Expands when chat starts */\n  overflow-y: auto;\n  border-radius: 10px;\n  /*border: 1px solid #ddd;*/\n  display: flex;\n  flex-direction: column;\n}\n\n/* Chat messages should be scrollable */\n.chat-messages {\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  max-height: calc(100vh - 200px); /* Prevents overflow */\n}\n\n/* Placeholder for empty chat */\n.empty-chat-placeholder {\n  text-align: center;\n  font-size: 18px;\n  color: #777;\n  margin: auto;\n}\n\n/* Individual chat messages */\n.chat-message {\n  margin-bottom: 10px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  max-width: 75%;\n}\n\n/* User messages */\n.chat-message.user {\n  align-self: flex-end;\n  background: #10a37f;\n  color: white;\n}\n\n/* Assistant messages */\n.chat-message.assistant {\n  align-self: flex-start;\n  background: var(--bg-color-back);\n}\n\n/* Sticky chat input */\n.chat-input-container {\n  display: flex;\n  align-items: center;\n  padding: 12px;\n  position: sticky;\n  margin-top: 10px;\n  border: 1px solid var(--bs-border-color-translucent);\n  border-radius: 8px;\n  bottom: 0;\n  width: 100%;\n}\n\n/* Chat input field */\n.chat-input {\n  flex-grow: 1;\n  border: none;\n  outline: none;\n  font-size: 16px;\n  padding: 12px 15px;\n  border-radius: 8px;\n}\n\n/* Chat input focus */\n.chat-input:focus {\n  box-shadow: 0 0 0 .25rem rgba(255, 77, 196, 0.25);\n  border: 0px solid #b3b3b3;\n}\n\n/* Send button (up arrow) */\n.send-btn {\n  background: #10a37f;\n  color: white;\n  border: none;\n  padding: 10px 14px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.2s ease-in-out;\n  margin-left: 10px;\n}\n\n.send-btn:hover {\n  background: #0e8c6a;\n}\n\n/* Up arrow icon size */\n.send-btn svg {\n  font-size: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
